"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsAdGroupManagement = exports.googleAdsAdGroupManagementArgsSchema = exports.GoogleAdsAdGroupAction = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// ---------- Create Ad Group ----------
var googleAdsCreateAdGroupInputSchema = zod_1.z
    .object({
    campaignId: zod_1.z.string().describe('The ID of the campaign where the ad group will be created'),
    name: zod_1.z.string().min(1).max(255).describe('Name for the new ad group'),
    bidAmount: zod_1.z
        .number()
        .positive()
        .nullish()
        .describe('Default CPC bid in micros (e.g., 1000000 = $1.00). Defaults to $1.00 if not specified.'),
    status: zod_1.z
        .enum(['ENABLED', 'PAUSED'])
        .default('ENABLED')
        .describe('Initial status for the ad group'),
})
    .describe('Create a new Google Ads ad group in the specified campaign.');
var googleAdsCreateAdGroupArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsCreateAdGroupInputSchema);
var googleAdsCreateAdGroupResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    adGroupId: zod_1.z.string().nullish(),
    resourceName: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
});
var googleAdsCreateAdGroupResultSchema = googleAdsCreateAdGroupResponseSchema;
// ---------- Update Ad Group ----------
var googleAdsUpdateAdGroupInputSchema = zod_1.z
    .object({
    adGroupId: zod_1.z.string().min(1).describe('The ID of the ad group to update'),
    name: zod_1.z.string().min(1).max(255).nullish().describe('New name for the ad group'),
    status: zod_1.z
        .enum(['ENABLED', 'PAUSED', 'REMOVED'])
        .nullish()
        .describe('New status for the ad group'),
    bidAmount: zod_1.z
        .number()
        .positive()
        .nullish()
        .describe('New default CPC bid in micros (e.g., 1000000 = $1.00)'),
})
    .describe('Update an existing Google Ads ad group.');
var googleAdsUpdateAdGroupArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsUpdateAdGroupInputSchema);
var googleAdsUpdateAdGroupResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    resourceName: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
});
var googleAdsUpdateAdGroupResultSchema = googleAdsUpdateAdGroupResponseSchema;
// ==========================
// Compound Tool: googleAdsAdGroupManagement
// ==========================
exports.GoogleAdsAdGroupAction = zod_1.z.enum(['createAdGroup', 'updateAdGroup']);
exports.googleAdsAdGroupManagementArgsSchema = zod_1.z.object({
    action: zod_1.z.discriminatedUnion('name', [
        zod_1.z.object({
            name: zod_1.z.literal('createAdGroup'),
            params: googleAdsCreateAdGroupArgsSchema.shape.args,
        }),
        zod_1.z.object({
            name: zod_1.z.literal('updateAdGroup'),
            params: googleAdsUpdateAdGroupArgsSchema.shape.args,
        }),
    ]),
    emitMode: zod_1.z.literal('single'),
});
var GoogleAdsAdGroupManagementAllResultsSchema = zod_1.z.union([
    googleAdsCreateAdGroupResultSchema,
    googleAdsUpdateAdGroupResultSchema,
]);
var googleAdsAdGroupManagementResultSchemas = (0, common_1.defineDynamicSchemas)()({
    dependencies: ['action.name'],
    variants: [
        { when: { 'action.name': 'createAdGroup' }, schema: googleAdsCreateAdGroupResultSchema },
        { when: { 'action.name': 'updateAdGroup' }, schema: googleAdsUpdateAdGroupResultSchema },
    ],
    defaultSchema: GoogleAdsAdGroupManagementAllResultsSchema,
});
exports.googleAdsAdGroupManagement = (0, common_1.createToolMetadata)({
    id: 'googleAdsAdGroupManagement',
    displayName: 'Google Ads Ad Group Management',
    displayDescription: 'Create and update Google Ads ad groups',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsAdGroupManagementArgsSchema,
}, googleAdsAdGroupManagementResultSchemas);
